<template>
  <div class="welfare-collection">
    <pageHeader title="领取福利" />
    <div class="container-top">
      <div class="walfare-item" v-for="(item, i) in waterList" :key="i" @click="welfareDetail(item)">
        <div class="water-info">
          <span>福利</span>
          <h1>{{ item.title }}</h1>
        </div>
        <div class="water-time">
          有效期：{{ item.startDate }}至{{ item.endTime }}
        </div>
      </div>
    </div>
    <div class="leaveMsg-btn" @click="customerDialogVirsble = true">联系客服领福利</div>
    <customerDialog
      v-if="customerDialogVirsble"
      v-model="customerDialogVirsble"
      @handleClose="dialogClose"
    />
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import customerDialog from "@/components/CustomerDialog";
export default {
  components: {
    pageHeader,
    customerDialog
  },
  data() {
    return {
      waterList: [],
      customerDialogVirsble: false
    };
  },
  mounted() {
    this.waterList = JSON.parse(this.$route.query.waterList);
  },
  methods: {
    welfareDetail(info) {
        this.$router.push({ path: '/welfareDetail', query: {
            welfareInfo: JSON.stringify(info)
        } })
    },
    dialogClose(action, done) {
      done();
    },
  }
};
</script>

<style lang="scss" scoped>
.welfare-collection {
  .container-top {
    width: 100%;
    height: 700px;
    background: url("~@/assets/images/balance-bg.png");
    background-size: 100% 100%;
    padding: 50px 30px;

    .walfare-item {
      width: 690px;
      height: 192px;
      background: #ffffff;
      box-shadow: 0px 0px 40px 0px rgba(171, 145, 134, 0.3),
        0px 0px 10px 0px rgba(149, 142, 139, 0.08);
      border-radius: 16px;
      padding: 30px;
      margin-bottom: 20px;

      .water-info {
        display: flex;
        align-items: flex-start;
        span {
          width: 80px;
          height: 30px;
          background: #ff7a3e;
          border-radius: 2px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 22px;
          color: #ffffff;
          text-align: center;
          line-height: 30px;
        }
        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #000000;
          margin-left: 20px;
          height: 90px;
        }
      }
      .water-time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #8f8f8f;
        line-height: 33px;
        margin-top: 20px;
      }
    }
  }
  .leaveMsg-btn {
    position: fixed;
    bottom: 10px;
    left: 40px;
    width: 640px;
    height: 80px;
    background: #ff7a3e;
    border-radius: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #ffffff;
    text-align: center;
    line-height: 80px;
    
  }
}
</style>


// WEBPACK FOOTER //
// src/views/welfareCollection/index.vue